import React from 'react';
import { PACARION_BRAND_COLOR, PACARION_SUPPORT_EMAIL } from '../shared/sponsorlessBrand';

/**
 * Pacarion entry on More when the homeowner has no sponsor.
 * The header keeps the wordmark. This page is only the support address.
 */
export default function PacarionHomeBrand({ colors, isDark, isMobile }) {
  const surface = (colors && colors.surface) || (isDark ? '#2a2a2a' : '#ffffff');
  const border = (colors && colors.border) || (isDark ? '#404040' : '#f0f0f0');
  const text = (colors && colors.text) || (isDark ? '#f9fafb' : '#1a1a1a');
  const muted = (colors && colors.textSecondary) || (isDark ? '#d1d5db' : '#666');
  const link = isDark ? PACARION_BRAND_COLOR : '#0f766e';

  return (
    <section
      data-testid="pacarion-support"
      aria-label="Pacarion"
      style={{
        background: surface,
        border: `1px solid ${border}`,
        borderRadius: '0.75rem',
        padding: isMobile ? '1.25rem' : '1.75rem',
        boxSizing: 'border-box',
        width: '100%',
        maxWidth: '100%',
        minWidth: 0,
      }}
    >
      <h2 style={{
        margin: '0 0 0.75rem',
        color: text,
        fontSize: isMobile ? '1.3rem' : '1.5rem',
        fontWeight: 300,
        letterSpacing: '0.05em',
      }}
      >
        Pacarion
      </h2>
      <a
        href={`mailto:${PACARION_SUPPORT_EMAIL}`}
        style={{ color: link, textDecoration: 'none', fontWeight: 500 }}
      >
        {PACARION_SUPPORT_EMAIL}
      </a>
      <p style={{ margin: '0.75rem 0 0', color: muted, fontSize: '0.9rem', lineHeight: 1.45 }}>
        Questions about the app go to Pacarion support.
      </p>
    </section>
  );
}
